const FlowArrowBottom = ({ className, fill, width = 40, height = 40 }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 40 40">
      <path data-name="사각형 3338" style={{ fill: 'none' }} d="M0 0h40v40H0z" />
      <g data-name="그룹 2526">
        <path
          data-name="합치기 25"
          d="M7635-3597v-6h-6v-6h6v-24h6v24h6v6h-6v6z"
          transform="translate(-7618 3635)"
          style={{ stroke: 'transparent', strokeMiterlimit: '10', fill }}
        />
        <path
          data-name="사각형 3336"
          transform="rotate(90 -4.5 15.5)"
          style={{
            fill,
          }}
          d="M0 0h6v6H0z"
        />
        <path
          data-name="사각형 3337"
          transform="rotate(90 7.5 27.5)"
          style={{
            fill,
          }}
          d="M0 0h6v6H0z"
        />
      </g>
    </svg>
  );
};

export default FlowArrowBottom;
